// @import
import { ensureHTMLElement, ensureProps } from "@src/js/lib/ensure";
import { addPrevNextBtnsClickHandlers } from "@src/js/lib/slider";
import Alpine from "alpinejs";
import EmblaCarousel from "embla-carousel";

Alpine.directive("slider-image-text", (element, {}, { cleanup }) => {
  const dom = {
    sliderLeft: ensureHTMLElement(element.querySelector(".c-slider-image-text__slider-left-viewport")),
    sliderRight: ensureHTMLElement(element.querySelector(".c-slider-image-text__slider-right-viewport")),
    prevButton: element.querySelector<HTMLElement>(".c-slider-image-text__btn-prev"),
    nextButton: element.querySelector<HTMLElement>(".c-slider-image-text__btn-next"),
    pagination: element.querySelector<HTMLElement>(".c-slider-image-text__pagination span"),
  };

  const hasSlider = ensureProps(dom, "prevButton", "nextButton", "pagination");
  if (!hasSlider) {
    return;
  }

  const sliderLeft = EmblaCarousel(dom.sliderLeft);
  const sliderRight = EmblaCarousel(dom.sliderRight);

  // Sync sliders
  sliderLeft.on("select", () => {
    const currentSlide = sliderLeft.selectedScrollSnap();
    sliderRight.scrollTo(currentSlide);
    dom.pagination.textContent = String(currentSlide + 1);
  });

  sliderRight.on("select", () => {
    const currentSlide = sliderRight.selectedScrollSnap();
    sliderLeft.scrollTo(currentSlide);
    dom.pagination.textContent = String(currentSlide + 1);
  });

  // Controls
  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(sliderLeft, {
    prevBtn: dom.prevButton,
    nextBtn: dom.nextButton,
  });

  cleanup(() => {
    sliderLeft.destroy();
    sliderRight.destroy();
    removePrevNextBtnsClickHandlers();
  });
});
